import React from "react";
import { Typography } from "antd";
import moment from "moment";
const { Text } = Typography;

const EndHour = (props) => {
  const { record, text } = props;
  var startOfDay = moment().startOf("day");
  const timeFromMidnight = record.start_time_minutes + text;
  const endDate = startOfDay.set("minute", timeFromMidnight);
  return <Text>{moment(endDate).format("HH:mm")}</Text>;
};

export default EndHour;
